// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'expose-loader?jQuery!jquery' // eslint-disable-line
import 'expose-loader?$!jquery' // eslint-disable-line
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueTouch from 'vue-touch';
// import 'nprogress/nprogress.css'
import "vue-loading-overlay/dist/vue-loading.css";

import VeeValidate from 'vee-validate';
import VueFormWizard from 'vue-form-wizard';
import {
  MobileValidate
} from '@/validates/MobileValidates'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import store from './store';
import router from './Routes';
import './permission' // permission control
import App from './App';
import moment from 'moment';
import $ from 'jquery'
import "chosen-js/chosen.min.css";
import "chosen-js/chosen.jquery.min.js";
import './registerServiceWorker'
Vue.use(BootstrapVue);
Vue.use(VueTouch);
Vue.use(VueFormWizard);
Vue.use(VeeValidate);
VeeValidate.Validator.extend('phone', MobileValidate);


Vue.config.productionTip = false;
Vue.config.developmentTip = false;

//  to get chosen dropdown
Vue.directive("chosen", {
  inserted: function (el, binding, vnode) {
    $(el)
      .chosen()
      .change(function (event, change) {
        if (Array.isArray(binding.value)) {
          var selected = binding.value;
          if (change.hasOwnProperty("selected")) {
            selected.push(change.selected);
          } else {
            selected.splice(selected.indexOf(change.deselected), 1);
          }
        } else {
          var keys = binding.expression.split(".");
          var pointer = vnode.context;
          while (keys.length > 1) {
            pointer = pointer[keys.shift()];
            pointer[keys[0]] = change.selected;
          }
        }
      });
  },
  componentUpdated: function (el) {
    $(el).trigger("chosen:updated");
  }
});
// to get state and country list details

Vue.mixin({
  methods: {
    getDetails(field, id, name) {
      if (typeof field[id] != 'undefined') {
        return field[id][name]
      } else {
        return ''
      }

    }
  }
})
//  to check routepermission available or not

Vue.mixin({
  methods: {
    RoutePermission(route, routeName, module, page, action) {
      const role = store.getters.role_name;
      if (role == 'admin') {
        return true
      } else if (route) {
        return Vue.prototype.$permissionDenied.indexOf(routeName) == -1 ? true : false
      } else {
        const isallowed = store.getters.isallowedroutes;
        return isallowed[page] && isallowed[page][action] ? isallowed[page][action] : false
      }
    }
  }
})
//  to get the json corresponding label of related key
Vue.mixin({
  methods: {
    getJsonPresentValue(arr, prop, val, name) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][name];
          break;
        }
      }
      return hasMatch;
    },
  }
})
//  to format the date
Vue.mixin({
  methods: {
    getDateFormat(date) {

      return date == null || date == '' ? "" : moment(date).format($.trim(store.getters.org_details.date_format))
    },
    inputUpper(value) {
      return value.toUpperCase()
    }
  }
});

const requireComponent = require.context(
  // The relative path of the components folder
  './components/Global',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Global[A-Z]\w+\.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
      .split('/')
      .pop()
      .replace(/\.\w+$/, '')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});